/* eslint-disable no-shadow */
import React, { useState } from 'react'
import {
  Dialog,
  Typography,
  DialogContent,
  DialogActions,
  FormHelperText,
  CircularProgress,
  FormControlLabel,
  DialogContentText,
  Paper,
} from '@material-ui/core'
import Button from 'src/components/sharedComponents/CustomButtons/Button'
import FormControl from '@material-ui/core/FormControl';
import { Autocomplete } from '@material-ui/lab'
import {
  useStyles,
  OrangeSwitch,
  OrangeCheckbox,
  OrangeTextField,
} from './styles'

const initialError = {
  nombre: '',
  unidadNegocio: '',
  marcas: '',
}

const VehiculosAdd = (props) => {
  const {
    form,
    isEdit,
    loading,
    onClose,
    controls,
    marcas,
    unidadNegocios,
    handleSubmit,
    onChangeInputs,
    openAddToSocio,
  } = props

  const [inputsStates, setInputsStates] = useState({
    inputUnidadNegocio: '',
    inputMarca: '',
    inputVehiculos: '',
  })

  const [error, setError] = useState(initialError)
  const disabled =
    error.nombre !== '' || error.unidadNegocio !== '' || error.marcas !== ''

  const classes = useStyles()
  const createTitle =
    'Cree un Establecimiento para agregarlo a la lista y relacionarlo con las reglas de leads.'
  const editTitle =
    'Edite un socio comercial, los cambios que realice no se podrán recuperar '

  console.log(form, 'form')

  return (
    <>
      <Dialog
        open={openAddToSocio}
        onClose={onClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Typography className={classes.mainTitle}>
          {isEdit ? 'Editar Vehículos' : 'Agregar Vehículos'}
        </Typography>
        <DialogContent>
          <DialogContentText>
            {isEdit ? editTitle : createTitle}
          </DialogContentText>
          <form action="/" onSubmit={handleSubmit}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <FormControlLabel
                label="Estado"
                control={
                  <OrangeSwitch
                    checked={Boolean(Number(form.estado))}
                    onChange={(e) => {
                      const isActive = e.target.checked ? 1 : 0
                      onChangeInputs(isActive, 'estado')
                    }}
                  />
                }
              />
            </div>

            <div>
                <Autocomplete
                  value={controls.unidadNegociosControl || null}
                  onChange={(event, newValueUnidad) => {
                    onChangeInputs(newValueUnidad, 'nombre_unidad_negocio')
                  }}
                  inputValue={inputsStates.inputUnidadNegocio || form.nombre_unidad_negocio}
                  onInputChange={(event, newInputValueUnidad) => {
                    setInputsStates({
                      ...inputsStates,
                      inputUnidadNegocio: newInputValueUnidad,
                    })
                  }}
                  id="nombre_unidad_negocio"
                  getOptionSelected={(e) =>
                    e.label === controls.unidadNegociosControl.label
                  }
                  options={unidadNegocios.map((negocio) => ({
                    label: negocio.nombre,
                    value: negocio.id,
                  }))}
                  renderInput={(params) => (
                    <OrangeTextField
                      required
                      {...params}
                      label="Unidad Negocio"
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: 'new-password',
                      }}
                    />
                  )}
                  getOptionLabel={(option) =>
                    option.label || form.nombre_unidad_negocio
                  }
                  PaperComponent={(props) => (
                    <Paper {...props} style={{ height: '150px' }} />
                  )}
                />
            </div>

            <div>
                <Autocomplete
                  value={controls.marcasControl || null}
                  onChange={(event, newValue) => {
                    onChangeInputs(newValue, 'marca')
                  }}
                  inputValue={inputsStates.inputMarcas || form.marca }
                  onInputChange={(event, newInputValue) => {
                    setInputsStates({
                      ...inputsStates,
                      inputMarca: newInputValue,
                    })
                  }}
                  id="marca"
                  getOptionSelected={(a) =>
                    a.label === controls.marcasControl.label
                  }
                  options={marcas.map((marca) => ({
                    label: marca.marca,
                    value: marca.marca,
                  }))}
                  renderInput={(params) => (
                    <OrangeTextField
                      required
                      {...params}
                      label="Marca"
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: 'new-password',
                      }}
                    />
                  )}
                  getOptionLabel={(option) => option.label || form.marca}
                  PaperComponent={(props) => (
                    <Paper {...props} style={{ height: '300px' }} />
                  )}
                />
            </div>

            <div>
              <OrangeTextField
                fullWidth
                value={form.linea || ''}
                onChange={(event) =>
                  onChangeInputs(event.target.value, 'linea')
                }
                required
                id="linea"
                name="linea"
                label="Nombre Vehículo"
              />
            </div>

            <DialogActions>
              {loading ? (
                <CircularProgress />
              ) : (
                <Button disabled={disabled} type="submit" color="warning">
                  Guardar
                </Button>
              )}
              <Button onClick={onClose}>Cerrar</Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default VehiculosAdd
